// tsconfig.core는 DOM lib를 의도적으로 제외한다. 아래 두 전역은 브라우저·Node 16+ 공통이며,
// 외부 IO 없이 입력 바이트만 변환하므로 이 디코더에 한해 최소 타입 표면으로 선언한다.
declare const atob: (data: string) => string;
declare const TextDecoder: { new(): { decode(input?: Uint8Array): string } };

// protobuf 경량 수동 디코더(의존성 0): 필요 필드만 — 1=id 2=price(f32) 9=dayVolume(sint64 zigzag)
export type YahooTick = { id: string; price: number; dayVolume: number | null };

/* varint 워킹 — [값, 다음 위치] */
function readVarint(buf: Uint8Array, pos: number): [bigint, number] {
  let r = 0n, s = 0n, p = pos;
  for (;;) {
    const b = BigInt(buf[p++]);
    r |= (b & 0x7fn) << s;
    if (!(b & 0x80n)) break;
    s += 7n;
    if (p > buf.length) break; // 손상 메시지 방어
  }
  return [r, p];
}

const zigzag = (n: bigint) => (n >> 1n) ^ -(n & 1n);

/** base64 PricingData → 틱. 형식 밖/결손 → null */
export function decodePricing(b64: string): YahooTick | null {
  let buf: Uint8Array;
  try {
    const bin = atob(b64);
    buf = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
  } catch {
    return null;
  }
  const dv = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
  let id = '', price = NaN, dayVolume: number | null = null;
  let p = 0;
  try {
    while (p < buf.length) {
      const [tag, np] = readVarint(buf, p);
      p = np;
      const field = Number(tag >> 3n), wt = Number(tag & 7n);
      if (wt === 0) {
        const [v, np2] = readVarint(buf, p); p = np2;
        if (field === 9) dayVolume = Number(zigzag(v));
      } else if (wt === 2) {
        const [len, np2] = readVarint(buf, p); p = np2;
        const end = p + Number(len);
        if (field === 1) id = new TextDecoder().decode(buf.slice(p, end));
        p = end;
      } else if (wt === 5) {
        if (field === 2) price = dv.getFloat32(p, true);
        p += 4;
      } else if (wt === 1) {
        p += 8;
      } else {
        return null; // 미지원 wire type = 포맷 변경 → 폐기 (폴링 폴백)
      }
    }
  } catch {
    return null;
  }
  if (!id || !Number.isFinite(price) || price <= 0) return null;
  return { id, price, dayVolume };
}
